module.exports = __webpack_public_path__ + "static/media/AMPL.d7d09228.png";